/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['./Rave2bundlepackedbubble'], function(Rave2bundlepackedbubble) {
	'use strict';
	class Rave2bundlehierarchicalpackedbubble extends Rave2bundlepackedbubble {

		constructor(){
			super();
		}

		get config(){
			const config = super.config;
			config.type = 'HierarchicalPackedBubble';
			delete config.thumbnail;

			config.properties.dataHandling.defaultValue = 'hierarchical';
			config.config.include.push('optimizeSize');
			return config;
		}

	}
	return Rave2bundlehierarchicalpackedbubble;
});